export function getFunctionName(func: Function): string {
    /* istanbul ignore next */
    if (func.name) {
        return func.name;
    } else {
        // IE11 does not support Function.name
        const matches = func.toString().match(/^function\s*([^\s(]+)/);
        return matches ? matches[1] : '';
    }
}
